<template>
  <div class="back-top">
    <span class="el-icon-mobile-phone" @mouseenter="ewmShow" @mouseleave="ewmhide"></span>
    <span v-if="backTopShow" class="el-icon-arrow-up" @click="backTop"></span>
    <div v-if="mobileEwmShow" class="mobile-ewm-box">
      <img src="../assets/images/app_code.jpg" alt="">
    </div>
    <!-- <div v-if="mobileEwmShow" class="mobile-ewm-box mobile-ewm-box-ios">
      <img src="../assets/images/mobile-ios-code.png" alt="">
      <p>下载iOS客户端</p>
    </div> -->
    <!-- <div v-if="mobileEwmShow" class="mobile-ewm-box">
      <img src="../assets/images/mobile-android-code.png" alt="">
      <p>下载安卓客户端</p>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "BackTop",
  data() {
    return {
      backTopShow:false,
      mobileEwmShow:false
    };
  },
  methods: {
    backTop() {
      window.scrollTo(0,0);
    },
    ewmShow() {
      this.mobileEwmShow = true
    },
    ewmhide() {
      this.mobileEwmShow = false
    }
  },
  mounted() {
    window.addEventListener("storage", e => {
      if (e.key == "UserToken") {
        this.userToken = e.newValue;
      } else if (e.key == "UserInfo") {
        this.userInfo = e.newValue && JSON.parse(e.newValue);
      }
    });
    window.addEventListener("scroll", () => {
      if(document.getElementsByClassName("back-top")){
        let scrollY = document.documentElement.scrollTop;
        this.backTopShow = scrollY > 300 ? true : false
      }
    });
  }
};
</script>

<style scoped lang="scss">
.back-top {
  position: fixed;
  bottom: 20%;
  right: 50%;
  margin-right: -550px;
  display: flex;
  flex-direction: column;
  span {
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 26px;
    background: #ebebeb;
    color: #a2a2a2;
    cursor: pointer;
    margin-bottom: 10px;
    &:hover {
      color: #317dff;
      background: #e5effe;
    }
  }
  .mobile-ewm-box {
    width: 123px;
    // height: 110px;
    position: absolute;
    left: 45px;
    top: 0;
    background: url('../assets/images/mobile-ewm-box.png') no-repeat center center;
    padding: 10px;
    img {
      width: 92px;
      height: 95px;
      display: block;
      margin-left: 9px;
    }
    p {
      width: 92px;
      margin-left: 9px;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      color: #333333;
    }
  }
  .mobile-ewm-box-ios {
      top:-126px;
      background: #fff;
      left:56px;
      width:108px;
      img {
      margin-left:-2px
      }
      p {
      margin-left:-2px
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BackTop.vue